import { render, staticRenderFns } from "./AvatarPack.vue?vue&type=template&id=b7f9d7d6&scoped=true"
import script from "./AvatarPack.vue?vue&type=script&lang=js"
export * from "./AvatarPack.vue?vue&type=script&lang=js"
import style0 from "./AvatarPack.vue?vue&type=style&index=0&id=b7f9d7d6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f9d7d6",
  null
  
)

export default component.exports